import { render } from "./12.vue?vue&type=template&id=24f4c0ed"
import script from "./12.vue?vue&type=script&lang=js"
export * from "./12.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__